/* Promo de árboles (19 al 25/10/2026). La carga el tema después de snippets/wk-promo-arboles.liquid, que antes deja
   window.WKP con: fase ('' | 'f0' | 'f1'), prevista (true en vista previa) y tote (handle real de la tote de regalo).
   0. Preparación: en vista previa, ?wkp_tote=X guarda X en sessionStorage 'wkp_tote' (con 'no' lo borra). El handle de la
      tote que se usa es ese guardado (solo en vista previa) o, si no hay, WKP.tote.
   1. Tote: lee /products/<handle>.js para saber el id de su variante y si el producto está disponible. Solo en la fase f1.
   2. Cesta (solo en la fase f1): si hay algún producto que no sea la tote, deja exactamente una tote (cantidad 1) marcada
      con la propiedad _wkp_regalo; si no hay otros productos, o la tote no está disponible o no existe, la quita.
      Escucha los cambios de la cesta que hace la web (fetch y XMLHttpRequest a /cart/add, change, update y clear),
      vuelve a pintar el carrito lateral y avisa con el evento 'wkp:cesta' en document.
   3. Ocultar la tote real (en cualquier fase): en el resto de la tienda (listados, buscador...) esconde los enlaces a
      WKP.tote, nunca a la tote de vista previa. Se repite al cargar y cuando cambia el DOM, como mucho una vez por fotograma. */
(function () {
  var W = window.WKP = window.WKP || {};
  var PROPIO = 'X-WKP';
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var activa = W.fase === 'f1';

  /* Lectura y escritura de sessionStorage: si el navegador lo bloquea, no pasa nada */
  function leerSS(clave) { try { return sessionStorage.getItem(clave); } catch (e) { return null; } }
  function guardarSS(clave, valor) {
    try { if (valor === null) sessionStorage.removeItem(clave); else sessionStorage.setItem(clave, valor); } catch (e) {}
  }

  /* 0. Preparación: handle de la tote y cabecera propia para las peticiones de este script */
  if (W.prevista) {
    var parametro = new URLSearchParams(location.search).get('wkp_tote');
    if (parametro !== null) guardarSS('wkp_tote', parametro === 'no' ? null : parametro);
  }
  function handleTote() {
    if (W.prevista) {
      var guardado = leerSS('wkp_tote');
      if (guardado && guardado !== 'no') return guardado;
    }
    return W.tote || '';
  }
  function api(ruta, cuerpo) {
    var cab = { 'Content-Type': 'application/json', Accept: 'application/json' };
    cab[PROPIO] = '1';
    return fetch(raiz + ruta, { method: cuerpo ? 'POST' : 'GET', headers: cab, credentials: 'same-origin', body: cuerpo ? JSON.stringify(cuerpo) : undefined })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  /* 1. Tote: id de su variante y si el producto está disponible (solo hace falta en la fase f1) */
  function cargarTote() {
    var h = handleTote();
    if (!h) return Promise.resolve(null);
    return fetch(raiz + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        return { id: v.id, disponible: !!p.available };
      })
      .catch(function () { return null; });
  }
  W.toteListo = activa ? cargarTote() : Promise.resolve(null);

  /* 2. Cesta (solo en la fase f1) */
  function secciones() { return document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble'; }
  function pintarSecciones(resp) {
    if (!resp || !resp.sections) return;
    var cd = document.querySelector('cart-drawer');
    var abierto = cd && cd.classList.contains('active');
    if (abierto && typeof cd.renderContents === 'function') {
      cd.renderContents(resp);
    } else {
      var lector = new DOMParser();
      Object.keys(resp.sections).forEach(function (id) {
        var nuevo = lector.parseFromString(resp.sections[id] || '', 'text/html');
        if (id === 'cart-drawer') {
          var dentro = nuevo.querySelector('#CartDrawer'), actual = document.querySelector('#CartDrawer');
          if (dentro && actual) actual.innerHTML = dentro.innerHTML;
        } else {
          var caja = document.getElementById(id), sec = nuevo.querySelector('.shopify-section');
          if (caja && sec) caja.innerHTML = sec.innerHTML;
        }
      });
    }
    if (cd && typeof resp.item_count === 'number') cd.classList.toggle('is-empty', resp.item_count === 0);
  }
  /* Rápido (16/10): sin esperar casi nada, aprovechando la cesta que ya devuelve Shopify al cambiarla (cart/change y cart/update)
     y pidiendo el carrito ya pintado en la misma petición que añade o quita la tote (sin la vuelta extra a cart/update). */
  var ocupado = false, otraVez = false, datosPendientes = null;
  function sincronizar(datos) {
    if (!activa) return;
    if (ocupado) { otraVez = true; datosPendientes = null; return; }
    ocupado = true;
    W.toteListo.then(function (t) {
      var cesta = datos && datos.items ? Promise.resolve(datos) : api('cart.js');
      return cesta.then(function (cart) {
        var deTote = cart.items.filter(function (i) { return t && i.variant_id === t.id; });
        var otras = cart.items.filter(function (i) { return !t || i.variant_id !== t.id; });
        var cant = deTote.reduce(function (s, i) { return s + i.quantity; }, 0);
        var quiere = t && t.disponible && otras.length > 0 ? 1 : 0;
        var bien = cant === quiere && (quiere === 0 || (deTote.length === 1 && deTote[0].properties && deTote[0].properties._wkp_regalo));
        if (bien) return false;
        var sec = { sections: secciones(), sections_url: location.pathname };
        function cambiar(i, cantidad, conSecciones) {
          var c = { id: i.key, quantity: cantidad };
          if (conSecciones) { c.sections = sec.sections; c.sections_url = sec.sections_url; }
          return api('cart/change.js', c);
        }
        var paso = Promise.resolve(null);
        if (quiere && deTote.length === 1 && deTote[0].properties && deTote[0].properties._wkp_regalo) {
          /* Solo sobra cantidad: se deja en 1 */
          paso = cambiar(deTote[0], 1, true);
        } else {
          /* Fuera todas las líneas de tote; la última petición trae el carrito pintado si ya no hay que añadir */
          deTote.forEach(function (i, n) {
            paso = paso.then(function () { return cambiar(i, 0, !quiere && n === deTote.length - 1); });
          });
          if (quiere) paso = paso.then(function () {
            return api('cart/add.js', { items: [{ id: t.id, quantity: 1, properties: { _wkp_regalo: '1' } }], sections: sec.sections, sections_url: sec.sections_url });
          });
        }
        return paso.then(function (resp) {
          pintarSecciones(resp);
          var cd = document.querySelector('cart-drawer');
          if (cd && quiere) cd.classList.remove('is-empty');
          document.dispatchEvent(new CustomEvent('wkp:cesta', { detail: resp }));
          return true;
        });
      });
    }).then(function (cambio) {
      /* En la página /cart no hay carrito lateral: se recarga una vez para que salga la tote (o deje de salir) */
      if (cambio && /\/cart\/?$/.test(location.pathname)) location.reload();
    }).catch(function () {}).then(function () {
      ocupado = false;
      if (otraVez) { otraVez = false; sincronizar(datosPendientes); datosPendientes = null; }
    });
  }
  W.sincronizar = sincronizar;
  var RUTA_CESTA = /\/cart\/(add|change|update|clear)/;
  var temporizador;
  function trasCambio(datos) { clearTimeout(temporizador); temporizador = setTimeout(function () { sincronizar(datos); }, 50); }
  if (activa) {
    var fetchOriginal = window.fetch;
    window.fetch = function (entrada, opciones) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var cab = opciones && opciones.headers, propio = false;
      if (cab) propio = typeof cab.get === 'function' ? !!cab.get(PROPIO) : !!cab[PROPIO];
      var p = fetchOriginal.apply(this, arguments);
      if (!propio && RUTA_CESTA.test(url)) {
        /* Se lee una copia de la respuesta (antes que el tema): si trae la cesta entera, no hace falta volver a pedirla */
        p.then(function (r) {
          var copia;
          try { copia = r.clone(); } catch (e) { trasCambio(null); return; }
          copia.json().then(function (j) { trasCambio(j && j.items && typeof j.item_count === 'number' ? j : null); }, function () { trasCambio(null); });
        }, function () {});
      }
      return p;
    };
    var abrirXhr = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (metodo, url) {
      if (RUTA_CESTA.test(String(url))) this.addEventListener('load', function () { trasCambio(null); });
      return abrirXhr.apply(this, arguments);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sincronizar(null); }); else sincronizar(null);
    window.addEventListener('pageshow', function (e) { if (e.persisted) sincronizar(null); });
  }

  /* 3. Ocultar la tote real (WKP.tote) en el resto de la tienda, en cualquier fase.
     Los enlaces dentro de la cesta no se tocan: ahí la tote sí tiene que verse. */
  var FUERA_DE_OCULTAR = 'cart-drawer-items, #main-cart-items, .cart-items, .cart-notification';
  /* Solo contenedores de tarjeta (nunca un <li> cualquiera: en el menú del móvil las tarjetas de "Lo más deseado" van sueltas
     dentro de la opción del menú y se escondería la opción entera). .wkn-c = complementos del carrito; .wkdm__c = "Lo más deseado" */
  var CAJAS = '.grid__item, .card-wrapper, .predictive-search__list-item, .swiper-slide, .slider__slide, .wkn-c, .wkdm__c';
  /* Nombre exacto: /products/<handle> seguido de /, ?, # o fin (no esconde otro producto cuyo handle empiece igual) */
  var reTote = W.tote ? new RegExp('/products/' + W.tote + '(?:[/?#]|$)') : null;  /* los handle de Shopify solo llevan a-z, 0-9 y guiones */
  function ocultar() {
    if (!W.tote) return;
    var enlaces = document.querySelectorAll('a[href*="/products/' + W.tote + '"]');
    for (var i = 0; i < enlaces.length; i++) {
      var enlace = enlaces[i];
      if (!reTote.test(enlace.getAttribute('href') || '')) continue;
      if (enlace.closest(FUERA_DE_OCULTAR)) continue;
      var contenedor = enlace.closest(CAJAS) || enlace;
      contenedor.style.display = 'none';
      contenedor.setAttribute('data-wkp-oculto', '1');
    }
  }
  var marcoOculto = 0;
  function ocultarEnFotograma() {
    if (marcoOculto) return;
    marcoOculto = requestAnimationFrame(function () { marcoOculto = 0; ocultar(); });
  }
  document.addEventListener('DOMContentLoaded', ocultar);
  ocultar();
  new MutationObserver(ocultarEnFotograma).observe(document.documentElement, { childList: true, subtree: true });
})();
